/**
 * Lo que el build dice del entorno donde corre la PWA.
 *
 * `VITE_ENTORNO_DE_DEMOSTRACION` la pone sólo el build de dev
 * (`.github/workflows/deploy-dev.yml`, DEMO-1). Local, CI y las capturas no la
 * tienen, así que el aviso de demostración queda apagado ahí y las capturas de
 * referencia no se mueven.
 */
export const ES_ENTORNO_DE_DEMOSTRACION = import.meta.env.VITE_ENTORNO_DE_DEMOSTRACION === 'si';
